import { AxiosError } from 'axios';
import { GET_ENABLED_MEDICAL_CONDITIONS_URL } from '../../constants/apiUrls';
import { GET_ENABLED_MEDICAL_CONDITIONS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface EnabledMedicalConditionResponse {
  name: string;
  dateTime: string;
  medicalConditions: MedicalCondition[];
}

export interface MedicalCondition {
  uuid: string;
  name: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: EnabledMedicalConditionResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetEnabledMedicalConditions = ({ onSuccess, onError }: Input = {}) => {
  const getEnabledMedicalConditions = async () => {
    const res = await axiosClient.get<EnabledMedicalConditionResponse>(
      GET_ENABLED_MEDICAL_CONDITIONS_URL
    );
    return res.data;
  };

  return useCustomQuery(GET_ENABLED_MEDICAL_CONDITIONS_QUERY_KEY, getEnabledMedicalConditions, {
    onSuccess,
    onError,
  });
};
